import { Outlet, useLocation } from "react-router-dom";
import AdminPanel from "../components/AdminPanel";
import PageTitle from "../components/PageTitle";
import PageContainer from "../components/PageContainer";

const TITLE_BY_PATH: Record<string, string> = {
    "/stats": "Statistiche",
    "/handle-activities": "Gestione attività",
    "/handle-companies": "Gestione aziende",
    "/handle-shop": "Gestione shop",
    "/handle-broadcast": "Comunicazioni",
    "/handle-home-carousel": "Hero Home",
};

export default function LayoutAdminDashboard() {
    const { pathname } = useLocation();
    const title = TITLE_BY_PATH[pathname] ?? "Dashboard admin";

    return (
        <PageContainer px="4" items="center" desktopItems="center" isRelative={false}>
            <PageTitle title={title} second="" backLink="/" noTitle={false} />

            <div className="flex flex-col gap-y-4">

                {/* SX: Pannello */}
                <AdminPanel />

                {/* DX: Contenuto */}
                <Outlet />
            </div>
        </PageContainer>
    )
}
